import { TOGGLE_SIDEBAR, HIDDEN_SIDEBAR, SHOW_SIDEBAR } from "../types";

export const toggleSidebar = () => dispatch => {
    dispatch({
        type: TOGGLE_SIDEBAR
    });
};

export const hiddenSidebar = () => dispatch => {
    dispatch({
        type: HIDDEN_SIDEBAR
    });
};

export const showSidebar = () => dispatch => {
    dispatch({
        type: SHOW_SIDEBAR
    });
};
